import { api } from './api'

const apiVersion = 'v2'

export const userApi = api
    .enhanceEndpoints({
        addTagTypes: ['User'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getUser: builder.query({
                query: ({ organisationId, userId }) =>
                    `/${apiVersion}/organisations/${organisationId}/webstoreusers/${userId}`,
                providesTags: ['User'],
            }),

            getOrCreateUserContext: builder.mutation({
                query: ({ organisationId, user }) => ({
                    url: `/${apiVersion}/organisations/${organisationId}/webstoreusers/context`,
                    method: 'POST',
                    body: user,
                }),
            }),

            getUserOrganisations: builder.query({
                query: ({ userId }) => `/${apiVersion}/webstoreusers/${userId}organisations`,
                transformResponse: (response) => {
                    response.sort((a, b) => {
                        return a.name.localeCompare(b.name)
                    })

                    return response
                },
            }),

            updateUser: builder.mutation({
                query: ({ organisationId, user, userId }) => ({
                    url: `/${apiVersion}/organisations/${organisationId}/webstoreusers/${userId}`,
                    method: 'POST',
                    body: user,
                }),
                invalidatesTags: ['User'],
            }),
        }),
    })

export const {
    useGetOrCreateUserContextMutation,
    useGetUserOrganisationsQuery,
    useGetUserQuery,
    useLazyGetUserOrganisationsQuery,
    useLazyGetUserQuery,
    useUpdateUserMutation,
} = userApi
